import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { useDispatch } from 'react-redux';

import { resetIsSignedOutManually } from 'modules/auth/store/authSlice';

export const RouteChangeListener = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(resetIsSignedOutManually());
  }, [location, dispatch]);

  return null;
};
